import { render, staticRenderFns } from "./PriceFrame.vue?vue&type=template&id=7a7d5660&scoped=true&"
import script from "./PriceFrame.vue?vue&type=script&lang=js&"
export * from "./PriceFrame.vue?vue&type=script&lang=js&"
import style0 from "./PriceFrame.vue?vue&type=style&index=0&id=7a7d5660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7d5660",
  null
  
)

export default component.exports